import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { ytVideoBroken } from 'Redux/ducks/events';
import { checkVideoData } from 'Api/Product/product-service';
import { countryCode } from 'Helpers/Geo/data';

export default function Video({ src, location }) {
  const [player, setPlayer] = useState(null);
  const playerContainer = useRef(<React.Fragment />);

  function checkValidity(event) {
    const isPlayable = get(event, 'target.playerInfo.videoData.isPlayable', false);
    const duration = get(event, 'target.playerInfo.duration', 0);
    const notPlayable = duration === 0 || !isPlayable;
    if (location === 'productCarousel' && notPlayable) {
      checkVideoData(src)
        .then((status) => {
          ytVideoBroken({ src, countryCode, location, status });
        });
    }

    return notPlayable;
  }

  function onReady(event) {
    checkValidity(event);

    // Autoplay fix for some mobile browsers
    const isPlayable = get(event, 'target.playerInfo.videoData.isPlayable', false);
    if (isPlayable) {
      try {
        event.target.playVideo();
      } catch (e) { /* */ }
    }
  }

  function loadPlayer() {
    if (player) {
      player.destroy();
    }
    if (!window.YT && !window.YT.Player) return;
    const createPlayer = new window.YT.Player(playerContainer.current, {
      videoId: src,
      playerVars: { autoplay: 1, hl: window.locale || 'en', modestbranding: 1 },
      events: {
        onReady,
        checkValidity,
      },
    });
    if (!window.fanYTPlayers) {
      window.fanYTPlayers = [];
    }
    window.fanYTPlayers.push(createPlayer);
    setPlayer(createPlayer);
  }

  function loadScript() {
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      loadPlayer();
    };
  }

  useEffect(() => {
    if (window.YT) {
      loadPlayer();
    } else {
      loadScript();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  return (
    <div ref={playerContainer} className="youtube-video" />
  );
}

Video.propTypes = {
  src: PropTypes.string.isRequired,
  location: PropTypes.string,
};

Video.defaultProps = {
  src: '',
  location: '',
};
